import { useGebruikerContext } from "../../Context/GebruikerContext";
import { DocumentenProvider } from "./context/DocumentenContext";
import { Card, CardBody } from "reactstrap";
import Loader from "react-loaders";
import DocTable from "./DocTable";
import SubstituteTable from "./SubstituteTable";
import Footer from "./Footer";

const Documenten = ({ children }) => {
	const { isLoading } = useGebruikerContext();
	if (isLoading) {
		return (
			<Card className="main-card">
				<CardBody className="d-flex flex-column">
					<Loader
						type="ball-grid-pulse"
						className={"mt-3 d-flex mx-auto justify-content-center"}
					/>
				</CardBody>
			</Card>
		);
	}
	return <DocumentenProvider>{children}</DocumentenProvider>;
};

Documenten.Wrapper = ({ children }) => {
	return <div className="row documenten">{children}</div>;
};

Documenten.DocTable = () => {
	return (
		<div className="col-12">
			<DocTable />
		</div>
	);
};

Documenten.SubstituteTable = () => {
	return (
		<div className="col-12">
			<SubstituteTable />
		</div>
	);
};

Documenten.Footer = () => {
	return (<Footer />)
};
export default Documenten;
